export const QueryParamsKeys = {
  PORTAL_SOURCE: 'portalSource',
  PORTAL_IDENTIFIER: 'portalIdentifier',
};

export const StoreKeys = {
  SSO_PORTAL_ELIGIBILITY_DATA: 'ssoPortalEligibilityData',
  EXISTING_REF_TOKEN: 'existingRefToken',
};

export const ConstantsLagoon = {
  CONTAINER_UI_MESSAGING: {
    INACTIVITY_MODAL_TITLE: 'INACTIVITY_MODAL_TITLE',
    INACTIVITY_MODAL_RENEW_SESSION: 'INACTIVITY_MODAL_RENEW_SESSION',
    INACTIVITY_MODAL_SIGN_OUT: 'INACTIVITY_MODAL_SIGN_OUT',
    INACTIVITY_MODAL_BODY_LINE_1: 'INACTIVITY_MODAL_BODY_LINE_1',
    INACTIVITY_MODAL_BODY_LINE_2: 'INACTIVITY_MODAL_BODY_LINE_2',
  },
  CONTAINER_CONFIG: {
    SESSION_TIMEOUT_MODAL_IDLE_OFFSET_SECS:
      'SESSION_TIMEOUT_MODAL_IDLE_OFFSET_SECS',
    SESSION_TIMEOUT_MODAL_LOGOUT_COUNTDOWN_SECS:
      'SESSION_TIMEOUT_MODAL_LOGOUT_COUNTDOWN_SECS',
    SESSION_TIMEOUT_MODAL_REFRESH_DELAY_SECS:
      'SESSION_TIMEOUT_MODAL_REFRESH_DELAY_SECS',
    SECURE_SESSION_ENDED: 'SECURE_SESSION_ENDED',
  },
};

export const TIMEOUT_MODAL_DEFAULTS = {
  IDLE_OFFSET_SECS: 300,
  LOGOUT_COUNTDOWN_SECS: 300,
  REFRESH_DELAY_SECS: 60,
};

export enum SessionInitStatus {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
